import { render, staticRenderFns } from "./m-plank-editer.vue?vue&type=template&id=42bc54e8&"
import script from "./m-plank-editer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-plank-editer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-plank-editer.vue?vue&type=style&index=0&id=42bc54e8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports